import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class DetalheDistribuicaoLimiteAgenteDto extends BaseEntity{
  public ideAgenteModalidade!: number;
  public nomeAgente: string;
  public cnpjAgente: string;

  public distribuicaoApuracaoRenuncia: LimiteAgenteApuracaoRenunciaDto;

  public fatorRedutorPrimeiraDistribuicao: number;
  public valorLimiteDisponivelInicioCiclo: number;
  public valorLimiteComplementarRecebidoPrimeiraDistribuicao: number;
  public valorLimiteComplementarRecebidoSegundaDistribuicaoCalculado: number;
  public valorLimiteComplementarRecebidoSegundaDistribuicaoRealizado: number;
  public valorLimiteComplementarRecebidoTerceiraDistribuicaoCalculado: number;
  public valorLimiteComplementarRecebidoTerceiraDistribuicaoRealizado: number;

  public valorEstipuladoMeta1PrimeiraDistribuicao: number;
  public valorEstipuladoMeta2PrimeiraDistribuicao: number;
  public valorEstipuladoMeta3PrimeiraDistribuicao: number;
  public valorEstipuladoMeta4PrimeiraDistribuicao: number;
  public valorEstipuladoMetaSegundaDistribuicao: number;
  public valorEstipuladoMetaTerceiraDistribuicao: number;

  public valorLimiteTotalInicioCiclo: number;
  public valorConsumidoCicloAnterior: number;

  public valorTotalContratadoNoCiclo: number;
  public valorTotalContratadoAdicionalRefCiclosAnteriores: number;
  public valorTotalCanceladoRefCiclosAnteriores: number;
  public valorTotalReducaoRefCiclosAnteriores: number;
  public valorLimiteDisponivelFimCiclo: number;

  public valorAtingidoMeta1PrimeiraDistribuicao: number;
  public valorAtingidoMeta2PrimeiraDistribuicao: number;
  public valorAtingidoMeta3PrimeiraDistribuicao: number;
  public valorAtingidoMeta4PrimeiraDistribuicao: number;
  public valorAtingidoMetaSegundaDistribuicao: number;
  public valorAtingidoMetaTerceiraDistribuicao: number;

  public valorTotalContratadoNoCicloDeLimiteAdicional: number;

  public dataCriacao: Date;
  public valorTotalRenunciaNoCiclo: number;
  public valorLimiteComplementarRecebidoRenuncia: number;
  public valorLimiteComplementarRecebidoRenunciaDoBolo: number;
  public agenteTemOperacaoComLimiteAdicionalNoCiclo: boolean;
}

export class LimiteAgenteApuracaoRenunciaDto extends BaseEntity {
  public dataApuracaoRenuncia!: Date;
  public valorRenunciado!: number;
  public valorLimiteDescomprometido!: number;
  public valorDistribuicao!: number;
  public bimestreUtilizado!: number;
}